﻿export class VXProxyUserV2ABI
{
    public static GetABI():any
    {
        return [
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "owner_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "uPLSToken_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "infController_",
                        "type": "address"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "stateMutability": "payable",
                "type": "fallback"
            },
            {
                "inputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "rateUPLS",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "uPLSInStake",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "PLSToSwap",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "lastSplitTimestamp",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "swapRouterV2",
                                "type": "address"
                            },
                            {
                                "internalType": "address[]",
                                "name": "swapPath",
                                "type": "address[]"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapMinPLSAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapMaxPLSAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "sendPLSIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "sendPLSReceiver",
                                "type": "address"
                            },
                            {
                                "internalType": "uint256",
                                "name": "bnsIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "sendAddress",
                                "type": "address"
                            },
                            {
                                "internalType": "bool",
                                "name": "isBurnWithERC20Burn",
                                "type": "bool"
                            }
                        ],
                        "internalType": "struct IVXS.Scope",
                        "name": "scope_",
                        "type": "tuple"
                    }
                ],
                "name": "configure",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "swapMaxSlippageIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapFrequencySeconds",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "splitFrequencySeconds",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "splitMinProfitAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "maxGasAmount",
                                "type": "uint256"
                            }
                        ],
                        "internalType": "struct IVXS.BotConfig",
                        "name": "botConfig_",
                        "type": "tuple"
                    }
                ],
                "name": "configureBot",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getBotConfig",
                "outputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "swapMaxSlippageIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapFrequencySeconds",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "splitFrequencySeconds",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "splitMinProfitAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "maxGasAmount",
                                "type": "uint256"
                            }
                        ],
                        "internalType": "struct IVXS.BotConfig",
                        "name": "",
                        "type": "tuple"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "getScope",
                "outputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "rateUPLS",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "uPLSInStake",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "PLSToSwap",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "lastSplitTimestamp",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "swapRouterV2",
                                "type": "address"
                            },
                            {
                                "internalType": "address[]",
                                "name": "swapPath",
                                "type": "address[]"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapMinPLSAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "swapMaxPLSAmount",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "sendPLSIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "sendPLSReceiver",
                                "type": "address"
                            },
                            {
                                "internalType": "uint256",
                                "name": "bnsIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "sendAddress",
                                "type": "address"
                            },
                            {
                                "internalType": "bool",
                                "name": "isBurnWithERC20Burn",
                                "type": "bool"
                            }
                        ],
                        "internalType": "struct IVXS.Scope",
                        "name": "",
                        "type": "tuple"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "infController",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "manager",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "owner",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "newPLSToSwap_",
                        "type": "uint256"
                    }
                ],
                "name": "setPLSToSwap",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "newRateUPLS_",
                        "type": "uint256"
                    }
                ],
                "name": "setRateUPLS",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "to_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount_",
                        "type": "uint256"
                    }
                ],
                "name": "transferPLS",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "to_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount_",
                        "type": "uint256"
                    }
                ],
                "name": "transferUPLS",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "uPLSToken",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "unstakeUPLS_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bool",
                        "name": "withPost_",
                        "type": "bool"
                    }
                ],
                "name": "unstakeFromVX",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "version",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "stateMutability": "payable",
                "type": "receive"
            }
        ];
    }
}